import type { Availability, ProductVariantAvailabilityWithChannel } from '@ab-core/graphql/dist';
import { HorizontalLine } from '@ab-core/horizontalline';
import useText from '@ab-core/localization/src/useText';
import Modal from '@ab-core/modal';
import { getTestIdProp } from '@ab-core/testing';
import Text from '@ab-core/text';
import type { FC } from 'react';
import React, { useState } from 'react';
import type { AvailabilitiesProps } from '..';
import { PickupChannelsWrapper } from './styled';

type PickupChannelsProps = Pick<
    Availability,
    'pickupChannelsAvailability' | 'deliveryFromFactory' | 'procuredProduct'
> &
    Pick<AvailabilitiesProps, 'quantityUnit'> & {
        isVisible: boolean;
    };

export const PickupChannels: FC<PickupChannelsProps> = (props) => {
    const { pickupChannelsAvailability, quantityUnit, isVisible } = props;
    const [modalOpen, setModalOpen] = useState(false);
    const moreChannelsLinkText = useText('productInfos.moreChannelsLink');
    const modalChannelSupplyText = useText('productInfos.modalChannelSupply');

    if (!isVisible) {
        return <></>;
    }

    return (
        <PickupChannelsWrapper>
            <div onClick={() => setModalOpen(true)} {...getTestIdProp('open-more-channels-modal-button')}>
                {pickupChannelsAvailability && pickupChannelsAvailability.length > 1 && (
                    <Text className="text-underline pointer full-width text-truncate" color="black">
                        {moreChannelsLinkText}
                    </Text>
                )}
            </div>
            <Modal
                onClose={() => setModalOpen(false)}
                md={6}
                lg={4}
                xl={4}
                open={modalOpen}
                headerText={modalChannelSupplyText}
            >
                <div style={{ width: '100%' }}>
                    {Array.isArray(pickupChannelsAvailability) &&
                        pickupChannelsAvailability.map((channel: ProductVariantAvailabilityWithChannel) => (
                            <React.Fragment key={channel?.channel?.key}>
                                <div className="flex-justify-content-space-between my-small3">
                                    <Text>{channel?.channel?.name}</Text>
                                    <Text color="success">
                                        {channel?.availability?.availableQuantity} {quantityUnit}
                                    </Text>
                                </div>
                                <HorizontalLine />
                            </React.Fragment>
                        ))}
                </div>
            </Modal>
        </PickupChannelsWrapper>
    );
};
